var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FmTabs',{staticClass:"status-tabs",attrs:{"value":_vm.value},on:{"change":_vm.change}},_vm._l((_vm.statusList),function(item,index){return _c('FmTabPane',{key:index,attrs:{"title":item.label,"name":item.key}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }